import type { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error) => {
      if ([401, 403].includes(error.status)) {
        // Se limpia la sesion para que la tienda vuelva a andar anonima.
        //
        // El backend solo deja pasar sin token las rutas publicas *cuando no
        // hay token*: si queda uno vencido guardado, se manda igual, y con el
        // rechazado se cae hasta el listado de productos. Antes no pasaba
        // porque la tienda nunca guardaba token.
        //
        // Se borran las claves a mano y no via UserService para no meter una
        // dependencia circular: ese servicio usa el mismo HttpClient.
        localStorage.removeItem('tknStore');
        localStorage.removeItem('tknStore-expiration');
        localStorage.removeItem('identity');
      } else if ([404].includes(error.status)) {
        console.log('Not Found');
      }

      const e = error.error?.message || error.statusText;
      console.error(e);
      return throwError(() => error)
    })
  )
};
